<template>
  <symbol
    id="star-empty"
    viewBox="0 0 31 29"
  >
    <path
      d="M15.4841 0.617432L19.4338 10.2572L30.4214 11.1058L22.1525 18.2627L24.622 28.6774L15.4857 23.0118L6.37816 28.3477L8.92634 18.2534L0.96582 11.1054L11.6834 10.2582L15.4841 0.617432ZM15.502 3.29863L12.3847 11.2059L3.36823 11.9186L10.0437 17.9127L7.93189 26.2784L15.5004 21.8442L23.09 26.5507L21.0396 17.9034L27.9546 11.9183L18.7422 11.2068L15.502 3.29863Z"
    />
  </symbol>
</template>
